import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var LinkIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.72 18.47a.75.75 0 1 0 1.06 1.06l7-7a.75.75 0 0 0 0-1.06l-7-7a.75.75 0 1 0-1.06 1.06l5.72 5.72H.75a.75.75 0 0 0 0 1.5h20.69l-5.72 5.72Z",
            clipRule: "evenodd"
        })
    }));
};
